interface ObjectTypeLabelProps {
  /** Already translated name of the kind of object, e.g. "Advertiser". */
  type: string
}

/**
 * Small greyed caption above a detail page title saying what kind of object
 * is open, so a page reached from a search or a deep link identifies itself.
 */
export function ObjectTypeLabel({ type }: ObjectTypeLabelProps) {
  return (
    <span className="mb-0.5 block text-xs font-semibold text-(--ad-text-muted)">
      {type}
    </span>
  )
}
